import { render, staticRenderFns } from "./verdict-objection-request.vue?vue&type=template&id=09b89fed&scoped=true&"
import script from "./verdict-objection-request.vue?vue&type=script&lang=js&"
export * from "./verdict-objection-request.vue?vue&type=script&lang=js&"
import style0 from "./verdict-objection-request.vue?vue&type=style&index=0&id=09b89fed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b89fed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
